import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = ({ onLanguageChange }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState('en'); // idioma actual

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLanguageToggle = () => {
    const newLang = currentLang === 'en' ? 'es' : 'en';
    setCurrentLang(newLang);
    onLanguageChange(newLang);
    setIsMobileMenuOpen(false); // cerrar menú al cambiar idioma
  };

  // Menú bilingüe + nueva opción Pricing/Precios
  const navItems = [
     { nameEn: 'Home', nameEs: 'Inicio', path: '/' },
  { nameEn: 'About Us', nameEs: 'Sobre nosotros', path: '/about' },
  { nameEn: 'Services', nameEs: 'Servicios', path: '/services' },
  { nameEn: 'Packages', nameEs: 'Paquetes', path: '/packages' },
  { nameEn: 'Contact', nameEs: 'Contacto', path: '/contact' },
];
  const mobileMenuVariants = {
    hidden: { x: '100%' },
    visible: { x: '0%' },
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', stiffness: 120, damping: 14 }}
      className="fixed top-0 left-0 w-full bg-fut-bg-dark bg-opacity-90 backdrop-blur-md z-50 shadow-lg border-b border-fut-border"
    >
      <div className="container mx-auto max-w-screen-xl px-6 py-4 flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <img
              src="/logo-header.webp"
              alt="San Jose Obrero LLC Logo"
              className="h-10 w-auto drop-shadow-lg"
            />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="text-fut-text-light text-lg font-bold hover:text-fut-primary transition-colors duration-300 relative group"
            >
              {currentLang === 'en' ? item.nameEn : item.nameEs}
              <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-fut-primary transition-all duration-300 group-hover:w-full"></span>
            </Link>
          ))}

          {/* Botón de idioma (desktop) */}
          <button
            onClick={handleLanguageToggle}
            className="text-fut-primary hover:text-fut-secondary transition-colors duration-300 focus:outline-none flex items-center space-x-2"
          >
            <Globe size={24} />
            <span className="text-lg font-bold">
              {currentLang === 'en' ? 'ES' : 'EN'}
            </span>
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={toggleMobileMenu}
            className="text-fut-primary focus:outline-none"
          >
            <Menu size={32} />
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={mobileMenuVariants}
            transition={{ type: 'spring', stiffness: 120, damping: 14 }}
            className="fixed top-0 right-0 h-full w-full bg-fut-bg-dark bg-opacity-95 backdrop-blur-lg z-50 p-6 md:hidden"
          >
            <div className="flex justify-end mb-8">
              <button
                onClick={toggleMobileMenu}
                className="text-fut-primary focus:outline-none"
              >
                <X size={32} />
              </button>
            </div>
            <nav className="flex flex-col items-center space-y-6">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={toggleMobileMenu}
                  className="text-fut-text-light text-2xl font-bold hover:text-fut-primary transition-colors duration-300"
                >
                  {currentLang === 'en' ? item.nameEn : item.nameEs}
                </Link>
              ))}

              {/* Botón idioma (mobile) */}
              <button
                onClick={handleLanguageToggle}
                className="text-fut-primary hover:text-fut-secondary transition-colors duration-300 focus:outline-none flex items-center space-x-2 text-2xl"
              >
                <Globe size={32} />
                <span className="font-bold">
                  {currentLang === 'en' ? 'Español' : 'English'}
                </span>
              </button>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Header;
